import { TagContainer } from './styled.js';
import { jsx } from 'react/jsx-runtime';

const Tag = props => {
  const {
    variant = 'gray',
    size = 'regular',
    children,
    dataTestid = 'tag'
  } = props;
  return /*#__PURE__*/jsx(TagContainer, {
    variant: variant,
    size: size,
    "data-testid": dataTestid,
    children: children
  });
};

export { Tag };
